// Bundle ATC — THG
// Multi-add cart logic for both mix & match and predefined bundles.
// Safe-by-default: does nothing unless [data-bundle-atc] exists.
(() => {
  const INIT_ATTR = 'data-bundle-atc-initialized';
  const ONE_SIZE = '__onesize__';

  // One-size bundles (e.g. wristbands) have no Size option at all.
  function hasSizeOption() {
    return !!document.querySelector('input[name$="-Size"]');
  }

  function getStockMap() {
    const el = document.querySelector('[data-bundle-stock-map]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch(e) { return null; }
  }

  function getPredefinedConfig() {
    const el = document.querySelector('[data-bundle-predefined-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch(e) { return null; }
  }

  function getPriceConfig() {
    const el = document.querySelector('[data-bundle-price-config]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch(e) { return {}; }
  }

  function getSelectedSize() {
    var el = document.querySelector('input[name$="-Size"]:checked');
    if (el) return el.value.trim();
    if (!hasSizeOption()) return ONE_SIZE;
    return '';
  }

  function getSelectedHandles() {
    const root = document.querySelector('[data-bundle-color-pickers]');
    if (!root) return [];
    const required = parseInt(root.dataset.requiredSlots || '0', 10);
    const handles = [];
    for (let i = 1; i <= required; i++) {
      const slot = root.querySelector('[data-bundle-slot="' + i + '"]');
      if (!slot) { handles.push(null); continue; }
      const sel = slot.querySelector('[data-bundle-color-swatch][aria-pressed="true"]');
      handles.push(sel ? sel.getAttribute('data-handle') : null);
    }
    return handles;
  }

  function getPackSize() {
    const root = document.querySelector('[data-bundle-color-pickers]');
    if (root) return parseInt(root.dataset.requiredSlots || '3', 10);
    const cfg = getPredefinedConfig();
    if (cfg && cfg.handles) return cfg.handles.length;
    return 3;
  }

  function getDiscountTitle(packSize) {
    const cfg = getPriceConfig();
    if (cfg.discountTiers) {
      const tier = cfg.discountTiers[String(packSize)];
      if (tier && tier.title) return tier.title;
    }
    return '';
  }

  function getDiscountPercent(packSize) {
    const cfg = getPriceConfig();
    if (cfg.discountTiers) {
      const tier = cfg.discountTiers[String(packSize)];
      if (tier) return tier.percent || 0;
    }
    return 0;
  }

  function lookupVariant(products, handle, size) {
    const prod = products[handle];
    if (!prod || !prod.sizes) return null;
    if (size === ONE_SIZE) {
      const k = Object.keys(prod.sizes);
      return k.length ? prod.sizes[k[0]] : null;
    }
    return prod.sizes[size] || null;
  }

  function setButtonState(btn, enabled, text) {
    if (!btn) return;
    const textEl = btn.querySelector('[data-bundle-atc-text]');
    if (enabled) {
      btn.removeAttribute('disabled');
      btn.setAttribute('aria-disabled', 'false');
    } else {
      btn.setAttribute('disabled', '');
      btn.setAttribute('aria-disabled', 'true');
    }
    if (text && textEl) textEl.textContent = text;
  }

  function updateCartBubble() {
    return fetch('/?section_id=cart-bubble')
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var countMatch = html.match(/\d+/);
        var bubble = document.getElementById('CartBubble');
        if (bubble) {
          if (countMatch) {
            bubble.classList.remove('hidden');
            bubble.innerHTML = countMatch[0];
          } else {
            bubble.classList.add('hidden');
            bubble.innerHTML = '';
          }
        }
      })
      .catch(function() {});
  }

  async function openCartDrawer() {
    var cartModal = document.querySelector('cart-modal');
    if (cartModal) {
      if (typeof cartModal.reloadContent === 'function') {
        await cartModal.reloadContent();
      }
      if (typeof cartModal.show === 'function') {
        cartModal.show();
      }
    }
  }

  async function addToCart(items, shellHandle) {
    const formData = new FormData();

    items.forEach((item, idx) => {
      formData.append('items[' + idx + '][id]', String(item.variantId));
      formData.append('items[' + idx + '][quantity]', '1');
      formData.append('items[' + idx + '][properties][_bundle_id]', item.bundleId);
      formData.append('items[' + idx + '][properties][_bundle_slot]', String(idx + 1));
      formData.append('items[' + idx + '][properties][_bundle_shell]', shellHandle);
      formData.append('items[' + idx + '][properties][_bundle_pack_size]', String(items.length));
      formData.append('items[' + idx + '][properties][_bundle_discount_title]', item.discountTitle);
      formData.append('items[' + idx + '][properties][_bundle_discount_percent]', String(item.discountPercent));
      formData.append('items[' + idx + '][properties][Color]', item.colorTitle);
      formData.append('items[' + idx + '][properties][Size]', item.size);
    });

    const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    const json = await res.json();
    if (!res.ok) throw new Error(json.description || 'Unable to add bundle to cart.');

    if (window.themeVariables?.settings?.cartType === 'page') {
      window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
      return;
    }

    updateCartBubble();
    await openCartDrawer();
  }

  function getSizeAvailability() {
    const cfg = getPredefinedConfig();
    if (!cfg || !cfg.handles || !cfg.products) return {};
    const allSizes = {};
    for (const handle of cfg.handles) {
      const prod = cfg.products[handle];
      if (!prod || !prod.sizes) continue;
      for (const [size, data] of Object.entries(prod.sizes)) {
        if (!(size in allSizes)) allSizes[size] = true;
        if (!data.available) allSizes[size] = false;
      }
    }
    return allSizes;
  }

  function updatePredefinedSizeAvailability(btn) {
    const allSizes = getSizeAvailability();

    document.querySelectorAll('input[name$="-Size"]').forEach(function(radio) {
      const size = radio.value.trim();
      if (!(size in allSizes)) return;
      const available = allSizes[size];
      if (available) {
        radio.classList.remove('option-unavailable');
      } else {
        radio.classList.add('option-unavailable');
      }
    });

    updatePredefinedButtonState(btn);
  }

  function updatePredefinedButtonState(btn) {
    const size = getSelectedSize();
    if (!size) {
      setButtonState(btn, false, 'Select a Size');
      return;
    }
    const allSizes = getSizeAvailability();
    if (allSizes[size] === false) {
      setButtonState(btn, false, 'Sold Out');
      return;
    }
    setButtonState(btn, true, 'Add Bundle to Cart');
  }

  function bind(btn) {
    if (btn.hasAttribute(INIT_ATTR)) return;
    btn.setAttribute(INIT_ATTR, 'true');

    const mode = btn.dataset.bundleMode || 'mix-match';
    const shellHandle = (window.meta?.product?.handle) || '';

    btn.addEventListener('click', async () => {
      try {
        btn.setAttribute('aria-busy', 'true');
        setButtonState(btn, false, 'Adding...');

        const size = getSelectedSize();
        if (!size) throw new Error('Please select a size.');
        const sizeProp = size === ONE_SIZE ? 'One Size' : size;

        const packSize = getPackSize();
        const discountTitle = getDiscountTitle(packSize);
        const discountPercent = getDiscountPercent(packSize);
        const bundleId = Date.now() + '-' + Math.random().toString(16).slice(2);

        let items = [];

        if (mode === 'predefined') {
          const cfg = getPredefinedConfig();
          if (!cfg || !cfg.handles || !cfg.products) throw new Error('Predefined config missing.');

          for (const handle of cfg.handles) {
            const variant = lookupVariant(cfg.products, handle, size);
            if (!variant) throw new Error('Size "' + size + '" not found for ' + handle);
            if (!variant.available) throw new Error(handle + ' is sold out in ' + size);
            items.push({
              variantId: variant.variantId,
              bundleId,
              discountTitle,
              discountPercent,
              colorTitle: cfg.products[handle].title || handle,
              size: sizeProp
            });
          }
        } else {
          const stockMap = getStockMap();
          if (!stockMap) throw new Error('Stock map missing.');

          const handles = getSelectedHandles();
          for (let i = 0; i < handles.length; i++) {
            const h = handles[i];
            if (!h) throw new Error('Select Color ' + (i + 1) + '.');
            const variant = lookupVariant(stockMap, h, size);
            if (!variant) throw new Error('Color ' + (i + 1) + ' doesn\'t have size ' + size + '.');
            if (!variant.available) throw new Error('Color ' + (i + 1) + ' is sold out in ' + size + '.');
            items.push({
              variantId: variant.variantId,
              bundleId,
              discountTitle,
              discountPercent,
              colorTitle: stockMap[h].title || h,
              size: sizeProp
            });
          }
        }

        await addToCart(items, shellHandle);
      } catch(err) {
        console.error('[bundle-atc]', err);
        alert(err.message || 'Unable to add bundle to cart.');
      } finally {
        btn.removeAttribute('aria-busy');
        if (mode === 'predefined') {
          updatePredefinedButtonState(btn);
        } else {
          setButtonState(btn, true, 'Add Bundle to Cart');
        }
      }
    });

    if (mode === 'predefined') {
      // Re-apply availability after every variant change (theme re-renders DOM on each change)
      document.addEventListener('variant:change', function() {
        setTimeout(function() { updatePredefinedSizeAvailability(btn); }, 50);
      });

      document.addEventListener('change', function(e) {
        if (e.target.matches && e.target.matches('input[name$="-Size"]')) {
          updatePredefinedButtonState(btn);
        }
      });

      // Initial state
      updatePredefinedSizeAvailability(btn);
    }
  }

  function boot() {
    document.querySelectorAll('[data-bundle-atc]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

